import { Injectable } from '@angular/core';
import { SharedRCAAdapter } from '../../../../../shared/shared-base.adapter';
import { RemoveDuplicatesPipe } from '@nationwide/internet-servicing-angular-pipes';
import { EcimAdapter } from '../../../../../shared/adapters/ecim.adapter';
import { PBS, ECIM } from '@nationwide/dgs-angular-billing-common';
import { SessionService } from '../../../../../shared/session/session.service';
import { IsbSharedCommonHelperService } from '../../../../../shared/isb-shared-common-helper.service';

type Agreement = PBS.Agreement;
type RetriveCustomerAgreementResponse = PBS.RetriveCustomerAgreementResponse;
type EnterpriseCustomerInformationManagementResponse = ECIM.EnterpriseCustomerInformationManagementResponse;

@Injectable()
export class ManagePaymentPrefsAdapter extends SharedRCAAdapter {

    constructor(
        removeDuplicatesPipe: RemoveDuplicatesPipe,
        private ecimAdapter: EcimAdapter,
        session: SessionService,
        protected sharedService: IsbSharedCommonHelperService
    ) {
        super(
            removeDuplicatesPipe,
            session,
            sharedService
        );
    }

    isEligibleForPaperless(internetRegistrationResponse: EnterpriseCustomerInformationManagementResponse): boolean {
        return this.ecimAdapter.getCanSelectPaperlessBilling(internetRegistrationResponse);
    }

    fetchBillingAccount(rca: RetriveCustomerAgreementResponse): Agreement {
        return this.getBillingAgreementFromRCA(this.getAgreementsFromRCA(rca));
    }

    fetchBillingAccountNumber(rca: RetriveCustomerAgreementResponse): string {
        const billingAgreemetResponse = this.fetchBillingAccount(rca);
        if (billingAgreemetResponse) {
            return billingAgreemetResponse.agreementNumber;
        }
    }

    fetchMostCurrentEmail(rca: RetriveCustomerAgreementResponse, internetRegistrationResponse: EnterpriseCustomerInformationManagementResponse): string {
        return this.ecimAdapter.getUpdatedEmailAddress(internetRegistrationResponse) || this.mapEmailAddress(rca);
    }

    fetchBillingAccountAmountDue(rca: RetriveCustomerAgreementResponse): string {
        return this.getAmountDueFromRCA(rca);
    }

    fetchBillingAccountAmountDueDate(rca: RetriveCustomerAgreementResponse): Date {
        return this.billingNextDueDate(rca);
    }

    fetchBillingAccountStatementDueDate(rca: RetriveCustomerAgreementResponse): Date {
        return this.billingStatementDueDate(rca);
    }

    checkLifeOnlyAccount(rca: RetriveCustomerAgreementResponse): boolean {
        return this.getLifeOnlyAccount(rca);
    }
}
